import AdminAssignedToDropdown from './AdminAssignedToDropdown';

export default AdminAssignedToDropdown;
